import { render, staticRenderFns } from "./ele7.vue?vue&type=template&id=971be40e&scoped=true"
import script from "./ele7.vue?vue&type=script&lang=js"
export * from "./ele7.vue?vue&type=script&lang=js"
import style0 from "./ele7.vue?vue&type=style&index=0&id=971be40e&prod&lang=scss"
import style1 from "./ele7.vue?vue&type=style&index=1&id=971be40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971be40e",
  null
  
)

export default component.exports